<script setup>
const props = defineProps({
  subtitle: {
    type: String,
    required: false,
    default: '',
  },
  title: {
    type: String,
    required: true,
  },
  shareUrl: {
    type: String,
    required: false,
    default: '',
  },
  shareMessage: {
    type: String,
    required: false,
    default: '',
  },
  sharePopupHeading: {
    type: String,
    required: false,
    default: '',
  },
});

const emit = defineEmits(['shareOpen', 'shareMethodSelect']);

const hasShareAction = computed(() => Boolean(props.shareUrl));

function handleShareOpen() {
  emit('shareOpen');
}

function handleShareMethodSelect(method) {
  emit('shareMethodSelect', method);
}
</script>

<template>
  <div
    class="hw-hero-title"
    role="region"
    :aria-label="title"
  >
    <div class="hw-hero-title-content">
      <h1 class="hw-hero-title-heading">
        {{ title }}
        <span v-if="subtitle">{{ subtitle }}</span>
      </h1>
    </div>
    <div
      v-if="hasShareAction"
      class="hw-hero-title-share-wrapper"
    >
      <CommonHwShare
        :shareable-url="shareUrl"
        :share-message="shareMessage"
        :popup-heading="sharePopupHeading"
        @share-open="handleShareOpen"
        @share-method-select="handleShareMethodSelect"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hw-hero-title {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: $wds-spacing-m;
  background: linear-gradient(90deg, $wds-color-purple-dark 25%, $wds-color-pink-dark 70%, $wds-color-pink 100%);
  border-radius: $wds-border-radius-xl;
  box-shadow: $wds-shadow-light-m;

  .hw-hero-title-content {
    display: flex;
    flex-direction: column;
    align-self: center;
    gap: $wds-spacing-xs;
    padding-right: $wds-spacing-l;

    .hw-hero-title-heading {
      @include title-5-bld;

      margin: 0;
      color: $wds-color-white;

      @include tablet {
        @include title-3-bld;
      }

      > span {
        display: block;

        @include title-4-bld;

        color: $wds-color-orange-light;

        @include tablet {
          @include title-1-bld;
        }
      }
    }
  }

  .hw-hero-title-share-wrapper {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: $wds-spacing-xxl;
    height: $wds-spacing-xxl;
    border-radius: 50%;
    box-shadow: $wds-shadow-light-m;
    transition: box-shadow 0.2s ease;

    &:hover {
      box-shadow: $wds-shadow-light-l;
    }
  }
}
</style>
